import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './theme/ThemeContext';

/**
 * Avvio comune dell'app (usato da index.js di ogni modulo).
 * - `serviceWorker` (default true): registra /service-worker.js, richiesto dai browser perché
 *   l'app sia installabile come PWA (vedi il pulsante "Installa l'app" nella schermata di login).
 * - `themeProvider` (default false): avvolge l'app in <ThemeProvider> (solo per i moduli il cui
 *   App.js non lo fa già).
 */
export function renderApp(App, { serviceWorker = true, themeProvider = false } = {}) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      {themeProvider ? <ThemeProvider><App /></ThemeProvider> : <App />}
    </React.StrictMode>
  );

  if (serviceWorker && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    });
  }
}
